import React from 'react';
import SeoLandingPage from '../components/SeoLandingPage';

const PageOptimisationFiscaleAnnecy = () => (
  <SeoLandingPage
    slug="optimisation-fiscale-annecy"
    title="Optimisation fiscale & défiscalisation Annecy - Arthur Vacogne CGP"
    description="Optimisation fiscale et défiscalisation à Annecy : Pinel, LMNP, Malraux, Monuments Historiques, PER, déficit foncier. Conseiller indépendant en Haute-Savoie. Bilan offert."
    keywords="optimisation fiscale Annecy, défiscalisation Annecy, défiscalisation Haute-Savoie, Pinel Annecy, LMNP Annecy, Malraux, Monuments Historiques, déficit foncier, déduction impôt revenu Annecy, IFI Annecy, réduction d'impôt Haute-Savoie"
    h1="Optimisation fiscale à Annecy : réduisez vos impôts intelligemment"
    subtitle="Vous payez trop d'impôts ? Plusieurs dispositifs légaux permettent de réduire significativement votre fiscalité tout en construisant un patrimoine. En tant que conseiller indépendant à Annecy, je sélectionne pour vous les solutions adaptées à votre situation."
    schemaService="Optimisation fiscale et défiscalisation à Annecy"
    sections={[
      {
        title: "Pourquoi optimiser sa fiscalité ?",
        body: "L'optimisation fiscale ne consiste pas à frauder mais à utiliser les dispositifs légaux mis en place par l'État pour orienter votre épargne vers des secteurs prioritaires (logement, rénovation, retraite, économie réelle). À Annecy comme partout en France, plusieurs leviers permettent de réduire votre impôt sur le revenu, votre IFI, ou de différer votre fiscalité dans le temps.",
        bullets: [
          "Réduction d'impôt directe (Pinel, Pinel+, Denormandie, Malraux, Monuments Historiques)",
          "Déduction fiscale (PER, déficit foncier, FCPI, FIP)",
          "Crédit d'impôt (emploi à domicile, dons)",
          "Différé d'imposition (assurance vie, PEA)",
          "Optimisation IFI (démembrement, nue-propriété)"
        ]
      },
      {
        title: "Les principales solutions de défiscalisation immobilière",
        body: "L'immobilier reste l'un des leviers les plus utilisés pour réduire ses impôts tout en se constituant un patrimoine tangible. Le choix du dispositif dépend de votre tranche marginale d'imposition, de votre horizon d'investissement et de vos objectifs.",
        bullets: [
          "Pinel & Pinel+ : jusqu'à 14% de réduction d'impôt sur 12 ans (immobilier neuf)",
          "LMNP (Loueur Meublé Non Professionnel) : revenus locatifs faiblement fiscalisés grâce à l'amortissement",
          "Denormandie : 12 à 21% de réduction d'impôt pour l'achat-rénovation en centre-ville",
          "Malraux : 22 à 30% de réduction d'impôt en secteur sauvegardé",
          "Monuments Historiques : déduction sans plafond pour les hauts revenus",
          "Déficit foncier : imputation des travaux sur le revenu global jusqu'à 10 700 € (ou 21 400 € pour rénovation énergétique)"
        ]
      },
      {
        title: "Les solutions de défiscalisation financière",
        body: "Au-delà de l'immobilier, plusieurs enveloppes fiscales permettent de réduire votre impôt ou de différer son paiement. Elles sont particulièrement adaptées aux dirigeants, cadres supérieurs et professions libérales à Annecy.",
        bullets: [
          "PER (Plan Épargne Retraite) : déduction des versements du revenu imposable (jusqu'à 10% des revenus pro)",
          "FCPI / FIP : 25% de réduction d'impôt pour investir dans des PME innovantes",
          "Assurance vie : différé d'imposition + abattement de 4 600 € (ou 9 200 € en couple) après 8 ans",
          "PEA : exonération totale d'impôt sur les plus-values après 5 ans (hors prélèvements sociaux)",
          "Girardin industriel : 110-120% de réduction d'impôt en one shot"
        ]
      },
      {
        title: "Comment se passe une optimisation fiscale à Annecy ?",
        body: "Toute optimisation fiscale commence par un audit complet de votre situation : revenus, patrimoine existant, projets, tranche marginale d'imposition. Je vous propose ensuite une stratégie sur-mesure, sans solution prédéfinie, en comparant l'ensemble des dispositifs du marché.",
        bullets: [
          "Audit fiscal complet de votre situation",
          "Simulation chiffrée du gain fiscal attendu",
          "Proposition de stratégie multi-dispositifs",
          "Mise en place et accompagnement administratif",
          "Suivi annuel et ajustement de la stratégie"
        ]
      }
    ]}
    faq={[
      { q: "Quel est le plafond de réduction d'impôt en France ?",
        a: "Le plafonnement global des niches fiscales est de 10 000 € par foyer fiscal et par an, sauf exceptions (Outre-mer 18 000 €, Malraux, Monuments Historiques et certains dispositifs spécifiques)." },
      { q: "Le PER est-il vraiment intéressant ?",
        a: "Le PER est particulièrement avantageux pour les contribuables avec une TMI supérieure ou égale à 30%. Les versements sont déductibles du revenu imposable, et la fiscalité à la sortie est généralement plus douce (TMI inférieure à la retraite)." },
      { q: "Faut-il choisir Pinel ou LMNP à Annecy ?",
        a: "Le choix dépend de votre objectif. Le Pinel offre une réduction d'impôt immédiate mais avec des contraintes (plafonds de loyers, durée de location). Le LMNP génère des revenus locatifs faiblement fiscalisés sur le long terme grâce à l'amortissement comptable. À Annecy, où la demande locative est forte, les deux dispositifs peuvent être pertinents selon votre stratégie." },
      { q: "Combien coûtent vos conseils en optimisation fiscale ?",
        a: "Le bilan patrimonial et la définition de stratégie sont entièrement gratuits. La rémunération s'effectue uniquement auprès des partenaires fournisseurs de solutions, sans honoraire client." }
    ]}
  />
);

export default PageOptimisationFiscaleAnnecy;
